import {
  LOCIZE_ERRORS_TRANSLATION_KEYS,
  LocizeNamespaces,
} from 'app-constants';
import { CONTACT_INFO } from 'environment';
import type { GraphQLErrorExtended } from 'models';
import { i18Next } from 'services';
import { getValidationMessage } from 'services/error-message-service';
import { toast as sonnerToast } from 'sonner';

export const useHandleErrors = () => {
  const { contactEmail } = CONTACT_INFO;

  const locizeErrorsEntries = Object.entries(LOCIZE_ERRORS_TRANSLATION_KEYS);
  // using i18Next instance here cause useTranslation hook triggers rerender of the whole client
  const handleGraphQLErrors = (errors: ReadonlyArray<GraphQLErrorExtended>) => {
    for (const error of errors) {
      const { code, message, validation } = error;
      const locizeErrorEntry =
        code &&
        locizeErrorsEntries.find(([, errorCode]) => +errorCode === +code);

      // DESCRIBED ERROR CODE CASE
      if (locizeErrorEntry) {
        i18Next.then((t) =>
          sonnerToast.error(
            t(
              LOCIZE_ERRORS_TRANSLATION_KEYS[
                locizeErrorEntry[0] as keyof typeof LOCIZE_ERRORS_TRANSLATION_KEYS
              ],
              {
                ns: LocizeNamespaces.errors,
                ...(code === +LOCIZE_ERRORS_TRANSLATION_KEYS.errorCode_2805
                  ? { contactEmail }
                  : {}),
              },
            ),
          ),
        );
        // VALIDATION MESSAGE ERROR CASE
      } else if (message === LOCIZE_ERRORS_TRANSLATION_KEYS.validationError) {
        const message = getValidationMessage(validation);

        i18Next.then((t) =>
          sonnerToast.error(
            t(message, {
              ns: LocizeNamespaces.errors,
            }),
          ),
        );

        // DEFAULT ERROR CASE
      } else {
        i18Next.then((t) =>
          sonnerToast.error(
            t(LOCIZE_ERRORS_TRANSLATION_KEYS.generalError, {
              ns: LocizeNamespaces.errors,
            }),
          ),
        );
      }
    }
  };

  return {
    handleGraphQLErrors,
  };
};
